import * as React from 'react';
import FooterOne from "../footer/FooterOne";
import HeaderOne from "../header/HeaderOne";
import Head from '../components/Head';
import Accordion from 'react-bootstrap/Accordion';
import '../components/AccordionOne.css';

const faqCategories = [
  {
    title: "Getting Started",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
    ),
    items: [
      {
        q: "What do I need to get started?",
        a: "An Android phone (any spare device works), a SIM card or eSIM with an SMS plan, and a stable internet connection. Install the TextLink gateway app, scan the QR code in your dashboard, and you're live in under 5 minutes."
      },
      {
        q: "Does TextLink work with iPhones?",
        a: "No. iOS doesn't expose the SMS APIs that TextLink needs to function. You need an Android device. You can use any cheap or spare Android phone — it doesn't have to be high-end."
      },
      {
        q: "Can I use my personal phone or do I need a separate device?",
        a: "You can use your regular Android phone, but for high-volume sending we strongly recommend a dedicated device so your personal number stays separate and safer from carrier limits."
      },
      {
        q: "Does it work with eSIMs?",
        a: "Yes. TextLink fully supports eSIMs. You can use a combination of physical SIM and eSIM on the same device. Performance is best with up to 2 SIMs per device."
      },
      {
        q: "Can I use virtual numbers like Google Voice or Onoff?",
        a: "No. TextLink requires a physical SIM or eSIM installed on an Android device. Virtual/VoIP numbers don't interface with the device's native SMS hardware, so they won't work."
      },
    ]
  },
  {
    title: "Pricing & Limits",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
    ),
    items: [
      {
        q: "What does \"unlimited messages\" mean?",
        a: "Unlimited on the TextLink side — we don't cap your messages. However, your mobile carrier has its own fair-usage policies. We recommend an unlimited SMS plan from your carrier and sending 300–400 messages per day per SIM to stay safe."
      },
      {
        q: "Are there additional per-message charges from TextLink?",
        a: "No. You pay the TextLink subscription and your carrier's SMS rates. TextLink does not charge per message on top of that."
      },
      {
        q: "What's the sending speed per SIM card?",
        a: "Approximately one message every 8 seconds per SIM. For higher volume, add more SIMs — for example, 3–4 SIMs can comfortably handle 1,000 texts per day."
      },
      {
        q: "How many SIMs can I run on one device?",
        a: "There's no hard limit, but performance drops noticeably after 2 SIMs per device. For more SIMs, we recommend adding additional phones."
      },
    ]
  },
  {
    title: "10DLC, Compliance & Carrier Risks",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
    ),
    items: [
      {
        q: "Do I need 10DLC or A2P registration?",
        a: "No. TextLink routes messages through your own SIM card, which is treated as P2P (person-to-person) communication. You skip the entire 10DLC/A2P registration process."
      },
      {
        q: "Can my SIM card get blocked by the carrier?",
        a: "It's possible if you send unsolicited messages at high volume. To prevent this: use the SMS warmup feature, send only to opted-in contacts, ramp up volume gradually, and stay within 300–400 messages per day per SIM."
      },
      {
        q: "Do I need consent from recipients?",
        a: "Yes. While formal carrier registration isn't required, legal compliance is mandatory. You must have documented permission from every recipient. Always include an opt-out mechanism (e.g., \"Reply STOP to opt-out\"). Sending cold unsolicited texts is the fastest way to get a number banned."
      },
      {
        q: "Can people text STOP to unsubscribe?",
        a: "Yes. TextLink supports opt-out handling."
      },
    ]
  },
  {
    title: "SMS Warmup",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2v10l4.24 4.24"/><circle cx="12" cy="12" r="10"/></svg>
    ),
    items: [
      {
        q: "What is SMS warmup?",
        a: "Warmup is a safety feature that gradually increases your daily sending volume over 21 days. It \"seasons\" your SIM card by mimicking natural growth in activity, which prevents carriers from flagging it as a bot. The system sends AI-generated messages to other TextLink users in the same region — just like email warmup, but for phone numbers."
      },
      {
        q: "What happens if my plan doesn't include warmup?",
        a: "Without warmup, you have to manually adjust your daily limits every few days to avoid sudden spikes that trigger a SIM ban. New SIM cards without gradual ramp-up are significantly more likely to be flagged and permanently disabled by carriers."
      },
      {
        q: "Can I see the warmup messages being sent?",
        a: "Warmup messages are handled under the hood by the system. They are AI-generated and sent to other TextLink users in your SIM's region to build carrier trust."
      },
    ]
  },
  {
    title: "GoHighLevel Integration",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>
    ),
    items: [
      {
        q: "How does the GoHighLevel integration work?",
        a: "TextLink installs as a native Conversation Provider in GHL. Every text, reply, and attachment flows through your GHL pipelines automatically. You can set up campaigns, automations, and AI agent responses directly in GHL."
      },
      {
        q: "How many GHL sub-accounts can I connect to one device?",
        a: "There's no limit. You can share a single SIM across multiple GHL sub-accounts — TextLink handles conversation separation behind the scenes."
      },
      {
        q: "Do replies show up in GHL?",
        a: "Yes. Replies appear both in GHL's unified inbox per contact and on the phone itself. You can respond from either place."
      },
      {
        q: "Will GHL charge me per message if I use TextLink?",
        a: "No. GHL does not charge per message when you use TextLink as your Conversation Provider."
      },
      {
        q: "Do I need GHL to use TextLink?",
        a: "No. GHL is just one integration. You can use the TextLink dashboard, API, or bulk sender entirely on their own without GHL."
      },
    ]
  },
  {
    title: "Features & Capabilities",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
    ),
    items: [
      {
        q: "Is this 2-way messaging? Can I receive replies?",
        a: "Yes. TextLink is fully 2-way. Replies show up in your dashboard, via webhook, and in GHL if connected."
      },
      {
        q: "Does TextLink support MMS?",
        a: "Not currently. MMS support is on the roadmap."
      },
      {
        q: "Does TextLink support voice calls?",
        a: "No. TextLink is SMS only. Calls will still come through to your phone normally, but TextLink doesn't manage them."
      },
      {
        q: "Can I send OTP / verification codes via API?",
        a: "Yes. We have dedicated API endpoints for generating, sending, and verifying one-time passwords. See the docs at docs.textlinksms.com/api#otp-phone-verification."
      },
      {
        q: "Can I send to international numbers?",
        a: "Yes. TextLink works in any country. Just make sure you know your carrier's international SMS rates to the destinations you're sending to."
      },
      {
        q: "Can I create sub-accounts for clients?",
        a: "Yes. You can create as many sub-accounts as you want and assign specific SIM cards and contacts to each one. Sub-accounts get their own dashboard. White-label UI is not available yet."
      },
      {
        q: "Which US carrier do you recommend?",
        a: "We maintain a carrier comparison sheet. Reach out to support or check the community for the latest version. In general, avoid carriers on T-Mobile's network for bulk sending as they tend to have stricter filtering."
      },
    ]
  },
];

function Faq() {
  return (
    <>
      <Head title="SMS Gateway FAQ — Setup, Pricing & Carrier Coverage" />
      <HeaderOne />

      <main className="fq">
        <div className="fq-container">

          {/* ---- HERO ---- */}
          <header className="fq-hero">
            <span className="fq-label">FAQ</span>
            <h1>Frequently asked questions</h1>
            <p>
              Everything you need to know about TextLink — setup, pricing, integrations, and compliance.
            </p>
          </header>

          {/* ---- FAQ SECTIONS ---- */}
          {faqCategories.map((cat, ci) => (
            <section key={ci} className="fq-section">
              <div className="fq-section-header">
                <div className="fq-section-icon">{cat.icon}</div>
                <h2>{cat.title}</h2>
              </div>
              <Accordion className="faq-accordion-modern">
                {cat.items.map((item, ii) => (
                  <Accordion.Item key={ii} eventKey={String(ii)}>
                    <Accordion.Header>{item.q}</Accordion.Header>
                    <Accordion.Body>
                      <p>{item.a}</p>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </section>
          ))}

          {/* ---- CTA ---- */}
          <section className="fq-cta">
            <h2>Still have questions?</h2>
            <p>Reach out to our team or join the Discord community for help.</p>
            <div className="fq-cta-buttons">
              <a className="fq-btn-primary" href="/Contact">
                Contact Us <span className="fq-arrow">→</span>
              </a>
              <a
                className="fq-btn-secondary"
                href="https://discord.gg/quhcCHPaZQ"
                target="_blank"
                rel="noopener noreferrer"
              >
                Join Discord
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" />
                </svg>
              </a>
            </div>
          </section>

        </div>
      </main>

      <FooterOne />

      <style jsx>{`
        .fq {
          padding: clamp(8rem, 14vh, 12rem) 0 clamp(3rem, 6vh, 5rem);
          background: #fafafa;
        }
        .fq-container {
          max-width: 760px;
          margin: 0 auto;
          padding: 0 clamp(1.25rem, 3vw, 2rem);
          box-sizing: border-box;
        }

        .fq-label {
          font-size: 0.6875rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          color: #71717a;
          display: block;
          margin-bottom: 0.75rem;
        }

        /* hero */
        .fq-hero {
          text-align: center;
          margin-bottom: clamp(3rem, 6vh, 5rem);
        }
        .fq-hero h1 {
          font-size: clamp(1.75rem, 4vw, 2.5rem);
          font-weight: 600;
          color: #18181b;
          letter-spacing: -0.04em;
          line-height: 1.15;
          margin-bottom: 1.25rem;
        }
        .fq-hero p {
          font-size: clamp(0.9375rem, 1.5vw, 1.0625rem);
          color: #71717a;
          max-width: 36rem;
          margin: 0 auto;
          line-height: 1.7;
        }

        /* sections */
        .fq-section {
          margin-bottom: clamp(2.5rem, 5vh, 3.5rem);
        }
        .fq-section-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1.25rem;
        }
        .fq-section-icon {
          color: #18181b;
          display: flex;
          align-items: center;
          flex-shrink: 0;
        }
        .fq-section-header h2 {
          font-size: clamp(1.25rem, 2.5vw, 1.5rem);
          font-weight: 600;
          color: #18181b;
          letter-spacing: -0.03em;
          margin: 0;
          line-height: 1.2;
        }

        /* cta */
        .fq-cta {
          text-align: center;
          padding: clamp(2.5rem, 5vw, 4rem) clamp(1.5rem, 3vw, 2rem);
          border-radius: 14px;
          background: #fff;
          border: 1px solid #e4e4e7;
          margin-top: clamp(2rem, 4vh, 3rem);
        }
        .fq-cta h2 {
          font-size: clamp(1.5rem, 3vw, 1.75rem);
          margin: 0 0 0.75rem;
          font-weight: 600;
          color: #18181b;
          letter-spacing: -0.03em;
        }
        .fq-cta p {
          color: #71717a;
          margin: 0 0 2rem;
          font-size: 1rem;
        }
        .fq-cta-buttons {
          display: flex;
          gap: 0.75rem;
          justify-content: center;
          flex-wrap: wrap;
        }

        /* buttons */
        .fq-btn-primary {
          background: #18181b;
          color: #fff;
          padding: 0.875rem 2rem;
          border-radius: 10px;
          font-weight: 500;
          font-size: 0.9375rem;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 0.375rem;
          transition: all 0.15s ease;
        }
        .fq-btn-primary:hover {
          background: #27272a;
          color: #fff;
          transform: translateY(-1px);
        }
        .fq-arrow {
          transition: transform 0.15s ease;
        }
        .fq-btn-primary:hover .fq-arrow {
          transform: translateX(2px);
        }
        .fq-btn-secondary {
          padding: 0.875rem 2rem;
          border-radius: 10px;
          font-weight: 500;
          font-size: 0.9375rem;
          text-decoration: none;
          background: transparent;
          color: #52525b;
          border: 1px solid #e4e4e7;
          display: inline-flex;
          align-items: center;
          gap: 0.375rem;
          transition: all 0.15s ease;
        }
        .fq-btn-secondary:hover {
          background: #fff;
          color: #18181b;
        }

        /* mobile */
        @media (max-width: 767px) {
          .fq {
            padding: 7rem 0 2rem;
          }
          .fq-hero h1 {
            font-size: 1.5rem;
          }
          .fq-cta-buttons {
            flex-direction: column;
            align-items: center;
          }
          .fq-btn-primary, .fq-btn-secondary {
            width: 100%;
            max-width: 280px;
            justify-content: center;
          }
        }
      `}</style>
    </>
  )
}

export default Faq;
